import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-vamaship',
  templateUrl: './admin-manage-vamaship.component.html',
  styleUrls: ['./admin-manage-vamaship.component.scss'],
})
export class AdminManageVamashipComponent implements OnInit {
  carrierNameError: string;
  authorizationError: string;
  vamashipData: any = {};
  carrierId: any;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.vamashipData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.vamashipData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  authorizationBlur() {
    this.authorizationError = "";
    if (!this.vamashipData.authorization) {
      this.authorizationError = 'Please enter authorization';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.authorizationError = "";

    if (!this.vamashipData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.vamashipData.authorization) {
      this.authorizationError = 'Please enter authorization';
    }
    if (this.carrierNameError != "" || this.authorizationError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "connectionName": this.vamashipData.connectionName,
      "carrierCode": this.vamashipData.carrierCode,
      "organizationId": this.vamashipData.organizationId,
      "carrierId": this.vamashipData.carrierId,
      "authorization": this.vamashipData.authorization
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Vamaship', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
